import { ReactNode } from "react";
import useInView from "../../hooks/useInView";
import { C } from "./designTokens";

interface FadeProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}

export default function Fade({ children, delay = 0, className = "" }: FadeProps) {
  const [ref, visible] = useInView();

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(20px)",
        transition: `opacity 0.6s ease ${delay}s, transform 0.6s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}
